import { render } from "./UiHeader.vue?vue&type=template&id=57bbc9dc&scoped=true&ts=true"
import script from "./UiHeader.vue?vue&type=script&lang=ts"
export * from "./UiHeader.vue?vue&type=script&lang=ts"

import "./UiHeader.vue?vue&type=style&index=0&id=57bbc9dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bbc9dc"]])

export default __exports__